import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SideNavComponent } from '../side-nav/side-nav.component';
import { NotFoundComponent } from '../components/not-found/not-found.component';
import {FundComponent} from "./fund/fund.component";
import { ReviewTimelineComponent } from "./review-timeline/review-timeline.component";

const routes: Routes = [
  {
    path: 'fund',
    component: SideNavComponent,
    children: [
      {
        path: ':id',
        component: FundComponent,
        data: { tab: 'fund', icon: 'home', type: 'fund' },
        pathMatch: 'full',
      },
      {
        path:"review-timeline/:id",
        component: ReviewTimelineComponent,
        data: {tab:'review timeline', icon:'timeline'},
        pathMatch:'full',
      },
      {
        path: '',
        component: NotFoundComponent,
        pathMatch: 'full',
      },
      {
        path: '**',
        component: NotFoundComponent,
        pathMatch: 'full',
      },
    ],
  },
  {
    path: 'certificated_outlet',
    component: SideNavComponent,
    children: [
      {
        path: ':id',
        component: FundComponent,
        data: {tab: 'certificated outlet', icon: 'home', type: 'certificated_outlet'},
        pathMatch: 'full',
      },
      {
        path: '',
        component: NotFoundComponent,
        pathMatch: 'full',
      },
      {
        path: '**',
        component: NotFoundComponent,
        pathMatch: 'full',
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FundRoutingModule {}
